import { STORAGE_KEYS } from '@/lib/constants/storage';

type TokenGetter = () => string | null;
type Handle401Fn = () => void;

let getTokenFn: TokenGetter = () => {
  const authDataStr = sessionStorage.getItem(STORAGE_KEYS.AUTH_DATA);
  if (!authDataStr) return null;
  try {
    const authData = JSON.parse(authDataStr);
    return authData?.apiKeyId ?? null;
  } catch {
    return null;
  }
};

let handle401Fn: Handle401Fn = () => {
  sessionStorage.removeItem(STORAGE_KEYS.AUTH_DATA);
  window.location.href = '/login';
};

export class AuthToken {
  static get(): string | null {
    return getTokenFn();
  }

  static handleUnauthorized(): void {
    handle401Fn();
  }

  static setGetter(getter: TokenGetter): void {
    getTokenFn = getter;
  }

  static setHandle401(handler: Handle401Fn): void {
    handle401Fn = handler;
  }
}
